
define('text!modules/strategy/supply/batch/templates/panel_layout.html',[],function () { return '<div class=\'column-A\'>\n    <div class=\'list-c\'>\n        <div class="grid-holder">\n            <div class="w-body batch-supply-list list-body">\n                <div class=\'browser-c\'></div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\'bins-column\'></div>';});

